import React from "react";

const BillLogo = ({ src, alt = "bill logo", style }) => {
  // Extract only safe style props that won't override dimensions
  const { marginTop, marginBottom, marginLeft, marginRight, margin, ...unsafeStyles } = style || {};
  
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: marginTop || 20,
        marginBottom: marginBottom,
      }}
    >
      <div
        style={{
          width: "182px",
          height: "140px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "5px",
          boxSizing: "border-box",
        }}
      >
        <img
          src={src}
          alt={alt}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
        />
      </div>
    </div>
  );
};

export default BillLogo;

